import React from 'react';

import { Route as StandardRoute } from 'react-router-dom';

import { TLanguage } from 'config/tenancy';
import { useAuth } from 'modules/authentication/presentation/contexts';

import { useRoute } from '../../hooks';
import { TRoutePaths } from '../../models';
import Redirect from '../Redirect';

type TAuthenticationType =
  | 'private'
  | 'public'
  | 'public_only'
  | 'private_by_document';

interface IRouteProps {
  path: TRoutePaths;
  exact?: boolean;
  component: React.ComponentType<any>;
  disabledTenancies?: TLanguage[];
  authentication?: TAuthenticationType;
}

const Route: React.FC<IRouteProps> = ({ path, authentication, ...rest }) => {
  const route = useRoute();
  const auth = useAuth();

  if (authentication === 'private' && !auth.session) {
    return (
      <Redirect
        to="/login"
        params={{
          origin: encodeURI(route.pathname + route.search),
        }}
      />
    );
  }

  if (authentication === 'private_by_document' && !auth.guestId) {
    return (
      <Redirect
        to="/autenticacao-documento"
        params={{
          origin: encodeURI(route.pathname + route.search),
        }}
      />
    );
  }

  if (authentication === 'public_only' && !!auth.session) {
    return <Redirect to="/area-cliente" />;
  }

  return <StandardRoute path={path} {...rest} />;
};

export default Route;
